// src/components/Toast/ToastContainer.jsx
import React, { useEffect } from 'react';
import { FiPackage, FiDollarSign, FiMessageCircle, FiAlertTriangle, FiAward, FiStar, FiBell, FiX } from 'react-icons/fi';
import './Toast.css';

// Mismo mapeo de tipos que NotificationItem (campana), para consistencia visual.
const TYPE_CONFIG = {
  order:   { Icon: FiPackage,       color: '#3b82f6' },
  payment: { Icon: FiDollarSign,    color: '#16a34a' },
  message: { Icon: FiMessageCircle, color: '#8b5cf6' },
  dispute: { Icon: FiAlertTriangle, color: '#f59e0b' },
  review:  { Icon: FiStar,          color: '#f59e0b' },
  trophy:  { Icon: FiAward,         color: '#f59e0b' },
  default: { Icon: FiBell,          color: '#00d412' },
};

function Toast({ toast, onDismiss }) {
  const cfg = TYPE_CONFIG[toast.type] ?? TYPE_CONFIG.default;
  const { Icon } = cfg;

  useEffect(() => {
    const t = setTimeout(() => onDismiss(toast.id), toast.duration ?? 5000);
    return () => clearTimeout(t);
  }, [toast.id, toast.duration, onDismiss]);

  const clickable = !!toast.onClick;

  return (
    <div
      className={`bp-toast ${clickable ? 'bp-toast-click' : ''}`}
      style={{ '--toast-color': cfg.color }}
      role="status"
      onClick={() => { if (clickable) { toast.onClick(); onDismiss(toast.id); } }}
    >
      <div className="bp-toast-icon" style={{ color: cfg.color, background: cfg.color + '1f' }}>
        <Icon />
      </div>
      <div className="bp-toast-body">
        {toast.title && <div className="bp-toast-title">{toast.title}</div>}
        <div className="bp-toast-msg">{toast.message}</div>
      </div>
      <button
        className="bp-toast-close"
        onClick={(e) => { e.stopPropagation(); onDismiss(toast.id); }}
        aria-label="Cerrar notificación"
      >
        <FiX />
      </button>
      <span className="bp-toast-progress" style={{ animationDuration: `${toast.duration ?? 5000}ms` }} />
    </div>
  );
}

export default function ToastContainer({ toasts, onDismiss }) {
  if (!toasts || toasts.length === 0) return null;
  return (
    <div className="bp-toast-container" aria-live="polite" aria-atomic="false">
      {toasts.map(t => <Toast key={t.id} toast={t} onDismiss={onDismiss} />)}
    </div>
  );
}
